'use client';

import React from 'react';

const BAR_HEIGHT = 24;
const BAR_RX = BAR_HEIGHT / 2;
const BAR_MIN_PCT = 6;

interface PreviewInlineBarProps {
  label: string;
  value: number;
  maxValue: number;
  formattedValue: string;
  color?: string;
}

const PreviewInlineBar: React.FC<PreviewInlineBarProps> = ({
  label,
  value,
  maxValue,
  formattedValue,
  color = 'fill-teal-500',
}) => {
  const widthPct = value > 0 && maxValue > 0 ? Math.min(Math.max((value / maxValue) * 100, BAR_MIN_PCT), 100) : 0;

  return (
    <div
      className="flex flex-col gap-1"
      data-testid="preview-inline-bar-item"
    >
      <div className="flex items-center justify-between">
        <span className="text-xs text-neutral-700 truncate">{label}</span>
        <span className="text-xs font-semibold text-neutral-800 tabular-nums flex-shrink-0">
          {formattedValue}
        </span>
      </div>
      <svg
        className="w-full"
        height={BAR_HEIGHT}
        role="img"
        aria-label={`${label}: ${formattedValue}`}
        data-testid="preview-inline-bar"
      >
        <rect
          width="100%"
          height={BAR_HEIGHT}
          rx={BAR_RX}
          className="fill-neutral-200"
          data-testid="preview-inline-bar-track"
        />
        {widthPct > 0 && (
          <rect
            width={`${widthPct}%`}
            height={BAR_HEIGHT}
            rx={BAR_RX}
            className={color}
            data-testid="preview-inline-bar-fill"
          />
        )}
      </svg>
    </div>
  );
};

export default PreviewInlineBar;
